import { IntroHeader } from "./IntroHeader";
import { EstimatedTimeHeader } from "./EstimatedTimeHeader";
import { TipBox } from "./TipBox";
import { GuideIntroduction } from "./GuideIntroduction";
import { DecisionStep } from "./DecisionStep";
import { Step } from "./Step";
import { FactoryTypes } from "../FactoryTypes";
import { WizardContainer } from "./WizardContainer";
import { FieldMapping } from "../../types";

export interface GuideContainer {
  introHeader?: IntroHeader;
  estimatedTimeHeader?: EstimatedTimeHeader;
  content?: GuideContentWrapped[];
  guideType?: GuideTypes;
}

export type GuideContentUnion = GuideIntroduction | DecisionStep | Step | TipBox | WizardContainer;
export type GuideContent = GuideContentUnion & {
  fieldMapping?: FieldMapping<GuideContentUnion>;
};

export type GuideContentWrapped = {
  type: FactoryTypes;
  content: GuideContent;
};

export enum GuideTypes {
  BACKUP = "backup",
  ACTIVATE = "activate",
  SETUP = "setup",
  SEND_BACK = "sendBack",
}
